/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * OTEL instrumentation scope
 */
export type OTELScope = {
  /**
   * Scope name
   */
  name?: string | undefined;
  /**
   * Scope version
   */
  version?: string | undefined;
};

/** @internal */
export type OTELScope$Outbound = {
  name?: string | undefined;
  version?: string | undefined;
};

/** @internal */
export const OTELScope$outboundSchema: z.ZodMiniType<
  OTELScope$Outbound,
  OTELScope
> = z.object({
  name: z.optional(z.string()),
  version: z.optional(z.string()),
});

export function otelScopeToJSON(otelScope: OTELScope): string {
  return JSON.stringify(OTELScope$outboundSchema.parse(otelScope));
}
